export default {
  title: "取消訂閱",
  processing: "正在處理您的取消訂閱請求...",
  success_title: "取消訂閱成功",
  success_message: "您已成功從我們的郵件列表中取消訂閱。",
  error_title: "取消訂閱失敗",
  error_message: "我們無法處理您的取消訂閱請求。請稍後再試。",
  go_home: "返回首頁",
};
